// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 2KXox9H52BbI
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEditSubscription.module.css"; // plasmic-import: 2KXox9H52BbI/css

createPlasmicElementProxy;

export const PlasmicEditSubscription__VariantProps = new Array();

export const PlasmicEditSubscription__ArgProps = new Array();

const $$ = {};

function PlasmicEditSubscription__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__fV07L
        )}
      >
        {"Subscription Status"}
      </div>
      <div
        data-plasmic-name={"subscriptionStatus"}
        data-plasmic-override={overrides.subscriptionStatus}
        className={classNames(projectcss.all, sty.subscriptionStatus)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__hGsL7
        )}
      >
        {"Subscription Cycle"}
      </div>
      <div
        data-plasmic-name={"cycleStack"}
        data-plasmic-override={overrides.cycleStack}
        className={classNames(projectcss.all, sty.cycleStack)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__bbTgo
        )}
      >
        {"Subscription Amount"}
      </div>
      <div
        data-plasmic-name={"subscriptionAmount"}
        data-plasmic-override={overrides.subscriptionAmount}
        className={classNames(projectcss.all, sty.subscriptionAmount)}
      />
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "subscriptionStatus", "cycleStack", "subscriptionAmount"],
  subscriptionStatus: ["subscriptionStatus"],
  cycleStack: ["cycleStack"],
  subscriptionAmount: ["subscriptionAmount"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEditSubscription__ArgProps,
          internalVariantPropNames: PlasmicEditSubscription__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEditSubscription__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEditSubscription";
  } else {
    func.displayName = `PlasmicEditSubscription.${nodeName}`;
  }
  return func;
}

export const PlasmicEditSubscription = Object.assign(
  // Top-level PlasmicEditSubscription renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    subscriptionStatus: makeNodeComponent("subscriptionStatus"),
    cycleStack: makeNodeComponent("cycleStack"),
    subscriptionAmount: makeNodeComponent("subscriptionAmount"),
    // Metadata about props expected for PlasmicEditSubscription
    internalVariantProps: PlasmicEditSubscription__VariantProps,
    internalArgProps: PlasmicEditSubscription__ArgProps
  }
);

export default PlasmicEditSubscription;
/* prettier-ignore-end */
